import React, { useState, useEffect } from "react";
import "../../Styles/FacultyLeave.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from '../../Components/Loader';

function FacultyLeave() {
    const [formData, setFormData] = useState({
        name: "",
        employeecode: "",
        leaveType: "",
        startDate: "",
        endDate: "",
        reason: "",
    });

    const [loading, setLoading] = useState(false);
    const [fetchingData, setFetchingData] = useState(true);
    const [isFormValid, setIsFormValid] = useState(false);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    toast.error("No authentication token found. Please log in.");
                    throw new Error("No authentication token found");
                }

                const response = await axios.get(
                    "https://api.uniums.com/api/faculty/user/details",
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                const { name, employeeCode } = response.data;

                setFormData((prevData) => ({
                    ...prevData,
                    name,
                    employeecode: employeeCode,
                }));
            } catch (err) {
                console.error("Error fetching user details:", err);
                toast.error("Failed to fetch user details. Please try again.");
            } finally {
                setFetchingData(false);
            }
        };

        fetchUserData();
    }, []);

    useEffect(() => {
        const { leaveType, startDate, endDate, reason } = formData;
        setIsFormValid(leaveType && startDate && endDate && reason);
    }, [formData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
            ...(name === "startDate" ? { endDate: "" } : {}),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                toast.error("No authentication token found. Please log in.");
                throw new Error("No authentication token found");
            }

            const data = {
                name: formData.name,
                employeeCode: formData.employeecode,
                leaveType: formData.leaveType,
                startDate: formData.startDate,
                endDate: formData.endDate,
                reason: formData.reason
            };
            const response = await axios.post(
                "https://api.uniums.com/api/faculty/apply-leave",
                data,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            toast.success("Leave application submitted successfully!");

            // Reset only the editable fields
            setFormData((prevData) => ({
                ...prevData,
                leaveType: "",
                startDate: "",
                endDate: "",
                reason: "",
            }));
        } catch (err) {
            toast.error("Failed to submit leave application. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (fetchingData) return <Loader />;

    return (
        <div className="faculty_leave_container">
            <ToastContainer />
            <h1 className="form_heading">Apply for Leave</h1>
            <form className="leave_form" onSubmit={handleSubmit}>
                <div className="form_row">
                    <div className="form_group">
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            disabled
                        />
                    </div>

                    <div className="form_group">
                        <label htmlFor="employeecode">Employee Code</label>
                        <input
                            type="text"
                            id="employeecode"
                            name="employeecode"
                            value={formData.employeecode}
                            onChange={handleChange}
                            disabled
                        />
                    </div>

                    <div className="form_group">
                        <label htmlFor="leaveType">Leave Type</label>
                        <select
                            id="leaveType"
                            name="leaveType"
                            value={formData.leaveType}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select leave type</option>
                            <option value="Casual Leave">Casual Leave</option>
                            <option value="Sick Leave">Sick Leave</option>
                            <option value="Earned Leave">Earned Leave</option>
                        </select>
                    </div>
                </div>

                <div className="form_row">
                    <div className="form_group">
                        <label htmlFor="startDate">Start Date</label>
                        <input
                            type="date"
                            id="startDate"
                            name="startDate"
                            value={formData.startDate}
                            onChange={handleChange}
                            min={new Date().toISOString().split("T")[0]}
                            required
                        />
                    </div>

                    <div className="form_group">
                        <label htmlFor="endDate">End Date</label>
                        <input
                            type="date"
                            id="endDate"
                            name="endDate"
                            value={formData.endDate}
                            onChange={handleChange}
                            min={formData.startDate || new Date().toISOString().split("T")[0]}
                            required
                            disabled={!formData.startDate}
                        />
                    </div>
                </div>

                <div className="form_row">
                    <div className="form_group">
                        <label htmlFor="reason">Reason</label>
                        <textarea
                            id="reason"
                            name="reason"
                            value={formData.reason}
                            onChange={handleChange}
                            placeholder="Provide a reason for leave"
                            rows="2"
                            required
                        ></textarea>
                    </div>
                </div>

                <button type="submit" className="submit_button" disabled={!isFormValid || loading}>
                    {loading ? "Submitting..." : "Submit"}
                </button>
            </form>
        </div>
    );
}

export default FacultyLeave;
